import type MarkdownIt from 'markdown-it';
import type StateCore from 'markdown-it/lib/rules_core/state_core.mjs';
import type Token from 'markdown-it/lib/token.mjs';

import { INLINE_LUMINA_STATUS_PREFIX } from '../../../inline-lumina';

const LUMINA_REGEX = /\[\^(lumina)\^\]/;

const inlineLumina = (state: StateCore) => {
	const tokens: Token[] = [];
	let luminaCounter = 0;

	for (const token of state.tokens) {
		const tokenChildren: Array<Token | null> = [];

		if (token.type !== 'inline' || (token.children && token?.children?.length <= 0)) {
			tokens.push(token);
			continue;
		}

		if (token.children) {
			token.children.forEach((childToken) => {
				if (childToken.type === 'text' && LUMINA_REGEX.test(childToken.content)) {
					const parts = childToken.content.split(LUMINA_REGEX);
					parts.forEach((part, index) => {
						if (index % 2 === 0) {
							const textToken = new state.Token('text', '', 0);
							textToken.content = part;
							textToken.level = childToken.level;
							tokenChildren.push(textToken);
						} else {
							const luminaToken = new state.Token('status', '', 0);
							luminaToken.content = '';
							luminaToken.block = false;
							luminaToken.level = childToken.level;
							luminaToken.attrs = [
								['localId', INLINE_LUMINA_STATUS_PREFIX + luminaCounter],
								['text', INLINE_LUMINA_STATUS_PREFIX + luminaCounter],
								['color', 'blue'],
							];
							tokenChildren.push(luminaToken);
							luminaCounter++;
						}
					});

					return;
				}

				tokenChildren.push(childToken);
			});
		}

		const filteredTokenChildren = tokenChildren.filter(
			(childToken) => childToken !== null,
		) as Token[];
		token.children = filteredTokenChildren;
		tokens.push(token);
	}

	state.tokens = tokens;
	return;
};

export default function mdPluginInlineLumina(md: MarkdownIt): void {
	md.core.ruler.push('inline-lumina', inlineLumina);
}
